import { DateTime } from 'luxon';
import { PaymentStatus, PaymentStatusEnum } from '../licences/PaymentStatus';
import { LicenseTachoModule } from '../modules/LicenseTachoModule';
import { LicenseTypeEnum } from '../licences/LicenseType';

export type UpdateLicenseVersion = {
    licenseNumber: string;
    licenseVersionId: string;
    validFrom?: DateTime;
    validTo?: DateTime;
    paymentDeadline?: DateTime;
    maximumNumberOfSupportedCars?: number;
    allowedModules?: Array<LicenseTachoModule>;
    paymentStatus?: PaymentStatusEnum;
    noCarsLimit?: boolean;
    includeBeta?: boolean;
    notes: string;
    distributorId?: string | null;
    type: LicenseTypeEnum;
};

export type UpdateLicenseVersionApi = {
    licenseNumber: string;
    licenseVersionId: string;
    validFrom?: string;
    validTo?: string;
    paymentDeadline?: string;
    maximumNumberOfSupportedCars?: number;
    allowedModules?: Array<LicenseTachoModule>;
    paymentStatus?: PaymentStatus;
    includeBeta?: boolean;
    type: LicenseTypeEnum;
    distributorId?: string | null;
    notes: string;
};

export const defaultUpdateLicenseVersionModel: UpdateLicenseVersion = {
    licenseNumber: '',
    licenseVersionId: '',
    validFrom: DateTime.fromISO(''),
    validTo: DateTime.fromISO(''),
    paymentDeadline: DateTime.fromISO(''),
    maximumNumberOfSupportedCars: 1,
    allowedModules: [],
    paymentStatus: PaymentStatusEnum.Awaiting,
    includeBeta: false,
    notes: '',
    distributorId: null,
    type: LicenseTypeEnum.Commercial,
};
